import { useMutation, useQueryClient } from "@tanstack/react-query";
import { storiesKeys } from "Api/Queries/Stories/useStoriesQuery";
import {
  putStoriesPublicID,
  type StorySaveRequest,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type UpdateStoryVariables = {
  publicID: string;
  story: StorySaveRequest;
};

type Props = {
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
};

/** Replaces a draft's or expired story's content; the server refuses it while the story is live. */
export const useUpdateStoryMutation = ({ onSuccess, onError }: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      ({ publicID, story }: UpdateStoryVariables) =>
        putStoriesPublicID(story, publicID),
    ),
    onSuccess: (_: unknown, { publicID }: UpdateStoryVariables) => {
      queryClient.invalidateQueries({ queryKey: storiesKeys.lists() });
      queryClient.invalidateQueries({ queryKey: storiesKeys.detail(publicID) });
      onSuccess?.();
    },
    onError,
  });
};
